import { useCallback } from "react";
import { stringify } from "query-string";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { IMessageBackEndModel } from "../types";

export default function () {
  const { request } = useApi();

  return {
    create: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.CREATE_MESSAGE,
        });
      },
      [request],
    ),

    fetchMessages: useCallback(
      async (option): Promise<{ data: IMessageBackEndModel[] }> => {
        return request({
          method: "GET",
          url: `${ApiRoutes.GET_MESSAGES + stringify(option)}`,
          shouldHandleError: true,
        });
      },
      [request],
    ),

    fetchConversations: useCallback(
      async (option) => {
        return request({
          method: "GET",
          url: `${ApiRoutes.GET_CONVERSATIONS + stringify(option)}`,
          shouldHandleError: true,
        });
      },
      [request],
    ),

    uploadAttachedFile: useCallback(
      (file) => {
        let formData = new FormData();
        formData.append("file", file);
        return request({
          method: "POST",
          url: `${ApiRoutes.UPLOAD_MESSAGE_ATTACHED_FILE}`,
          data: formData,
        });
      },
      [request],
    ),
  };
}
